import React from "react";

import QuestionQcu from "./QuestionQcu";

export default function QuestionYesNo(props) {
    return <QuestionQcu {...props} />;
}
